export default __webpack_public_path__ + "static/media/curators_group.1dfa839f.svg";